import * as React from "react";
import {
  Text,
  View,
  TouchableOpacity,
  // Alert, a part of cleaner code
  Image,
  StyleSheet,
  ImageBackground,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";

import { useNavigation } from "@react-navigation/native";
// import TransactionList from "../components/TransactionList"; a part of cleaner code
// import TransactionActions from "../redux/actions/TransactionActions"; a part of cleaner code
// import { useSelector } from "react-redux"; a part of cleaner code
import GlobalStyles from "../components/GlobalStyles";

function ButtonClickCheckFunction() {
  // Alert.alert("Button Clicked");
}

export default function InvestModify() {
  const navigation = useNavigation();
  return (
    <ScrollView style={styles.scrollArea}>
      <View style={GlobalStyles.containerW}>
        <View style={GlobalStyles.headerContainerKL}>
          <View style={GlobalStyles.headerTextP}>
            <Text style={GlobalStyles.headingStyle}>My Portfolio</Text>
            <Text style={GlobalStyles.subheaderStyle}>
              Current allocation shown. Make changes to suit your investment
              preferences.
            </Text>
          </View>
        </View>
        <View style={GlobalStyles.bodyContainerI}>
          <View style={styles.centerContent}>
            <TouchableOpacity
              style={styles.SubmitButtonStyle}
              activeOpacity={0.5}
              onPress={ButtonClickCheckFunction}
            >
              <Text style={styles.TextStyleW}> CONSERVATIVE </Text>
            </TouchableOpacity>
          </View>
          <View style={styles.infoBox}>
            <Image
              style={styles.infoImage}
              source={require("../assets/images/invest/modify.png")}
            />
          </View>
        </View>
      </View>
      <View style={styles.portfolioContainer}>
        <ImageBackground
          source={require("../assets/images/invest/portfolio.png")}
          style={styles.imageBG}
        >
          <View style={styles.portfolioTop}>
            <View style={styles.splitBox}>
              <Text style={styles.TextStyleAU}>AU</Text>
              <Text style={styles.TextStyleDollars}>$2,400</Text>
            </View>
            <Text style={styles.TextStyleBalance}>Balance at 21st May</Text>
          </View>
          <View style={styles.portfolioBottom}>
            <Text style={styles.TextStyleExplore}>
              Explore Investment Choices
            </Text>
            <View style={styles.splitBoxOptions}>
              <TouchableOpacity
                style={GlobalStyles.TextStyleLink}
                activeOpacity={0.5}
                onPress={() => navigation.navigate("InvestOptionDetail")}
              >
                <View style={styles.optionBox}>
                  <Text style={styles.TextStyleOption}>Term Deposits</Text>
                </View>
              </TouchableOpacity>
              <View style={styles.optionBox}>
                <Text style={styles.TextStyleOption}>Australian Property</Text>
              </View>
              <View style={styles.optionBox}>
                <Text style={styles.TextStyleOption}>International Shares</Text>
              </View>
            </View>
          </View>
        </ImageBackground>
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  portfolioContainer: {
    textAlign: "center",
  },

  splitBox: {
    flexDirection: "row",
    alignItems: "flex-end",
  },

  splitBoxOptions: {
    flexDirection: "row",
    alignItems: "flex-end",
    paddingLeft: 20,
  },

  optionBox: {
    height: 70,
    width: 120,
    paddingTop: 15,
    paddingLeft: 20,
    marginLeft: 20,
    marginTop: 20,
    backgroundColor: "#352641",
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    borderWidth: 1,
    borderColor: "#cccccc",
    borderBottomWidth: 0,
  },

  portfolioBG: {},

  portfolioTop: {
    height: 200,
    paddingTop: 85,
    paddingLeft: 80,
  },

  portfolioBottom: {
    height: 128,
    paddingTop: 20,
    justifyContent: "flex-start",
  },

  bodyMiddleBG: {
    height: 274,
    position: "absolute",
    top: 0,
    left: 0,
  },

  scrollArea: {
    flex: 1,
    backgroundColor: "#2e7fa1",
  },
  centerHeaderContent: {
    flex: 1,
    justifyContent: "center",
    paddingRight: 100,
  },

  centerContent: {
    justifyContent: "center",
  },

  SubmitButtonStyle: {
    marginTop: 0,
    paddingTop: 10,
    paddingBottom: 10,
    marginLeft: 50,
    marginRight: 50,
    marginBottom: 10,
    backgroundColor: "#B4C55B",
    borderRadius: 20,
    borderWidth: 1,
    borderColor: "#fff",
  },

  linkStyle: {
    borderBottomWidth: 2,
    borderColor: "#FFC72C",
  },

  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },

  TextStyleW: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },

  TextStyleExplore: {
    color: "#fff",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },

  TextStyleOption: {
    color: "#fff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  TextStyleLink: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 12,
  },

  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "left",
    marginBottom: 5,
  },

  TextStyleAU: {
    fontFamily: "montserrat-light",
    fontSize: 48,
    color: "#D4EBF3",
    textAlign: "left",
    marginBottom: 5,
  },
  TextStyleDollars: {
    fontFamily: "montserrat-medium",
    fontSize: 57,
    color: "#ffffff",
    textAlign: "left",
    marginBottom: 5,
  },
  TextStyleBalance: {
    fontFamily: "montserrat-regular",
    fontSize: 14,
    color: "#D4EBF3",
    textAlign: "left",
    marginBottom: 5,
  },

  infoBox: {
    backgroundColor: "#ffffff",
    borderRadius: 30,
    marginBottom: 20,
  },

  infoImage: {
    width: "100%",
    height: 275,
    resizeMode: "contain",
  },

  infoImageX: {
    width: 375,
    height: 328,
    resizeMode: "cover",
  },

  imageBG: {
    flex: 1,
    resizeMode: "cover",
    justifyContent: "flex-start",
  },
});
